import { LayoutComponent } from '../layout/layout.component';
import { LoginComponent } from '../authentication/signin/login.component';
import { SignUpComponent } from '../authentication/signup/signup.component';

export const routes = [
    {
        path: '',
        component: LayoutComponent,
        children: [
            { path: 'admin', loadChildren: '../admin/admin.module#AdminModule', pathMatch: 'prefix' },
            { path: 'user', loadChildren: '../user/user.module#UserModule', pathMatch: 'prefix' },
            { path: '', redirectTo: 'user', pathMatch: 'prefix' }
        ]
    },

    { path: 'signin', component: LoginComponent },
    { path: 'signup/:token', component: SignUpComponent },
    { path: '**', redirectTo: 'admin' }
];

